import {localStorageHelper} from "../helpers/LocalStorageHelper";
import store from '../store';
import {reloadPage} from "./DOM";

/**
 * Help function for logout
 */
const authLogOut = () => {
    if (store.getters["isLoggedIn"]) {
        removeCurrentAccessToken()
        reloadPage()
    }
}

/**
 * Help function for saving access token
 *
 * @param {string} token
 */
const saveAccessToken = (token) => {
    localStorageHelper.setItem(`access_token_${getWallboardNumber()}`, token)
}

/**
 * Help function for deleting current access token
 */
const removeCurrentAccessToken = () => {
    try {
        localStorageHelper.removeItem(`access_token_${getWallboardNumber()}`)
    } catch (e) {
        console.error(e)
    }
}

/**
 * Help function for returning current access token
 *
 * @returns {string|null}
 */
const getCurrentAccessToken = () => {
    try {
        return localStorageHelper.getItem(`access_token_${getWallboardNumber()}`)
    } catch (e) {
        console.error(e)
        return null
    }
}

/**
 * Help function for return wallboard number
 *
 * @returns {string}
 */
const getWallboardNumber = () => {
    const number = location.pathname.split('/').pop()
    const reg = /^\d+$/

    if (!reg.test(number)) {
        throw new Error("Wallboard number not valid")
    }

    return number
}

export { authLogOut, saveAccessToken, getWallboardNumber, getCurrentAccessToken, removeCurrentAccessToken }